import { Link } from "react-router-dom";
import EventCard from "@/components/ui/EventCard";
import { events } from "@/mocks/events";

export default function EventShowcase() {
  const [lead, ...rest] = events;
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
              事件地图 · EVENT MAPS
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              最新事件地图专区
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              时间线到关键人物，各方观点到网友评论，外加「已证实 / 未证实」清单，一次看全。
            </p>
          </div>
        </div>

        {/* 置顶大卡 */}
        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <Link to={`/events/${lead.slug}`} className="flex flex-col md:flex-row" aria-label={lead.title}>
              <div className="relative aspect-[16/9] w-full overflow-hidden bg-background-200 md:aspect-auto md:w-1/2">
                <img
                  src={lead.cover}
                  alt={lead.coverAlt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  热度 {lead.heat}
                </span>
              </div>
              <div className="flex flex-1 flex-col justify-center p-5 md:p-6">
                <span className="flex items-center gap-2 text-xs text-accent-700">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-800">{lead.category}</span>
                  更新于 {lead.updated}
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                  {lead.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {lead.summary}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
                  查看事件地图
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </Link>
          </article>

          {/* 榜单小卡 */}
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-list-check-3 text-lg text-accent-600" aria-hidden="true"></i>
              事件速览
            </h3>
            <ul className="mt-3 space-y-1">
              {rest.slice(0, 4).map((e) => (
                <li key={e.slug}>
                  <Link
                    to={`/events/${e.slug}`}
                    className="flex items-center gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
                  >
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-semibold text-secondary-900">
                      <i className="ri-road-map-line" aria-hidden="true"></i>
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm text-foreground-800">{e.title}</span>
                      <span className="mt-0.5 block text-xs text-foreground-500">
                        {e.category} · {e.readingMinutes} 分钟读完
                      </span>
                    </span>
                    <i className="ri-arrow-right-line text-foreground-300" aria-hidden="true"></i>
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              to="/events"
              className="mt-3 flex items-center justify-center gap-1.5 rounded-md border border-background-200 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-200 hover:text-primary-700"
            >
              查看更多地图
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

        {/* 其余卡片 */}
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {rest.slice(4).map((e) => (
            <EventCard key={e.slug} event={e} />
          ))}
        </div>
      </div>
    </section>
  );
}